import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBHZyopNsobj0KIUAnPR8qj6futPlTqfmI",
  authDomain: "aromatica-evt-quiz.firebaseapp.com",
  projectId: "aromatica-evt-quiz",
  storageBucket: "aromatica-evt-quiz.appspot.com",
  messagingSenderId: "143096736942",
  appId: "1:143096736942:web:d7303eeccdba0a61c7d13f",
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
export default firebase;
